import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ControlChartsManagementView } from "src/components/views/spc/masterData/controlCharts/ControlChartsManagementView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/spc/controlCharts")({
	staticData: { title: i18n.t("control_charts"), legacyViewKey: "controlChartsPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <ControlChartsManagementView />;
}
